import {View} from 'MWC';
import tpl from '../templates/CalculatorDropdownNew.jsx';
import React from 'react';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);
        this.state = {
            ui: this.uiStates.INITIAL,
            open: false
        };

        this.dropdownRef = React.createRef();
        return this;
    }

    toggleOpen = () => {
        this.setState({open: !this.state.open});
    };

    handleSelect = value => {
        const {name, onChange} = this.props;
        if (onChange) {
            onChange({target: {name, value, props: {name}}});
        }
        this.setState({open: false});
    };

    handleClickOutside = e => {
        if (this.dropdownRef.current && !this.dropdownRef.current.contains(e.target)) {
            this.setState({open: false});
        }
    };

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }
}
